module.exports = __webpack_public_path__ + "img/cg_logo_white.d366bb79.svg";